import React from 'react';

import Hero from '../components/sections/Hero';
import TrustStrip from '../components/sections/TrustStrip';
import Collections from '../components/sections/Collections';
import House from '../components/sections/House';
import Editorial from '../components/sections/Editorial';
import Showroom from '../components/sections/Showroom';
import Reels from '../components/sections/Reels';
import Visit from '../components/sections/Visit';

export function Home() {
  return (
    <>
      <Hero />
      <TrustStrip />
      <Collections />
      <House />
      <Editorial />
      <Showroom />
      <Reels />
      <Visit />
    </>
  );
}

export default Home;
